import { render, staticRenderFns } from "./BlockedEmail.vue?vue&type=template&id=4daf7fbc&lang=pug"
import script from "./BlockedEmail.vue?vue&type=script&lang=js"
export * from "./BlockedEmail.vue?vue&type=script&lang=js"
import style0 from "./BlockedEmail.vue?vue&type=style&index=0&id=4daf7fbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports